import styled from 'styled-components'
import AppButton from 'Components/AppButton'

import { BREAK_POINT_LG } from '@CSSVars/variables'
import { TERTIARY_COLOR, SITE_NAVY_COLOR, GREY_BACKGROUND, SELECTED_ITEM_BG_COLOR } from '@CSSVars/colors'


export const _CompareCta = styled(AppButton)`
  position: relative;
  height: 22px;

  color: ${({ active }) => (active ? 'white' : TERTIARY_COLOR)};
  border-color: ${({ active }) => (active ? SITE_NAVY_COLOR : TERTIARY_COLOR)};
  background-color: ${({ active }) => (active ? SITE_NAVY_COLOR : 'transparent')};
  cursor: pointer;
  svg {
    margin-right: 5px;
    ${({ active }) => (active ? ' path { fill: white; stroke: white; }' : '')};
  }
  @media (hover:hover) {
    &:hover {
      background: ${GREY_BACKGROUND};
      ${({ active }) => (active ?
    `
            color: ${TERTIARY_COLOR};
            svg {
              path {
                  stroke: ${TERTIARY_COLOR};
                }
            }
        ` : ''
  )}
    }
    }
  }

  &:active {
    background-color: ${SELECTED_ITEM_BG_COLOR};
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
  }
`
